/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_hint_number = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a whole number from 1 to 3999.`)
};

const es_rn_hint_number = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa un número entero del 1 al 3999.`)
};

const de_rn_hint_number = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geben Sie eine ganze Zahl von 1 bis 3999 ein.`)
};

const nl_rn_hint_number = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voer een geheel getal in van 1 tot 3999.`)
};

const fr_rn_hint_number = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrez un nombre entier de 1 à 3999.`)
};

const it_rn_hint_number = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inserisci un numero intero da 1 a 3999.`)
};

const pt_br2_rn_hint_number = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Digite um número inteiro de 1 a 3999.`)
};

const pt_rn_hint_number = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Introduza um número inteiro de 1 a 3999.`)
};

const ja_rn_hint_number = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1〜3999の整数を入力してください。`)
};

const zh_rn_hint_number = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请输入一个 1 到 3999 之间的整数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_hint_number = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_hint_number(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_hint_number", locale)
	if (locale === "en") return en_rn_hint_number(inputs)
	if (locale === "es") return es_rn_hint_number(inputs)
	if (locale === "de") return de_rn_hint_number(inputs)
	if (locale === "nl") return nl_rn_hint_number(inputs)
	if (locale === "fr") return fr_rn_hint_number(inputs)
	if (locale === "it") return it_rn_hint_number(inputs)
	if (locale === "pt-BR") return pt_br2_rn_hint_number(inputs)
	if (locale === "pt") return pt_rn_hint_number(inputs)
	if (locale === "ja") return ja_rn_hint_number(inputs)
	return zh_rn_hint_number(inputs)
};